import { useWorkspaceId } from "../../hooks/useWorkspaceId";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useHttpTaxManagerAppHeaders } from "../utils/useHttpTaxManagerAppHeaders";
import { BASE_API_URL, HttpError } from "../utils/useTaxManagerAppQueryClient";

interface ReopenFulfilmentRequest {
    levyId: string;
    taxPayerWorkspaceId: string;
    year: number;
}

export function useReopenFulfilment() {
    const { t } = useTranslation();
    const workspaceId = useWorkspaceId();
    const headers = useHttpTaxManagerAppHeaders({ method: "POST" });
    const queryClient = useQueryClient();

    const mutation = useMutation<boolean, Error, ReopenFulfilmentRequest>({
        mutationFn: async (request) => {
            const response = await fetch(
                `${BASE_API_URL}/tenants/${workspaceId}/fulfilments/${request.levyId}/years/${request.year}/tax-payers/${request.taxPayerWorkspaceId}/activities/reopen`,
                {
                    headers,
                    method: "POST",
                },
            );

            if (!response.ok) {
                throw new HttpError(response);
            }

            return true;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["useGetFulfilmentActivities"],
            });
            queryClient.invalidateQueries({
                queryKey: ["useGetFulfilmentDetail"],
            });
            queryClient.invalidateQueries({ queryKey: ["useGetFulfilments"] });
            queryClient.invalidateQueries({ queryKey: ["useGetKPIs"] });
        },
        meta: {
            errorMessage: t("errors.messages.reopenFulfilment"),
        },
    });

    return mutation;
}
